import { Observable } from "rxjs";
import * as http from "../../../../../../../services/http.service";
import { IFlyerDetailPagePosition } from "../../../../../types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.interface";
import { map } from "rxjs/operators";
import { FlyerDetailPagePositionResponse } from "../types/flyer-detail-page-position-response/flyer-detail-page-position-response.interface";
import {
  mapFlyerDetailPagePositionFormToRequest,
  mapFlyerDetailPagePositionResponseToIFlyerDetailPagePosition,
} from "../types/flyer-detail-page-position-response/flyer-detail-page-position-response.functions";
import { FlyerDetailPagePositionForm } from "../features/flyer-detail-page-form-position/types/flyer-detail-page-position-form.interface";

export function createPagePosition(
  pageId: number,
  templatePositionId: number
): Observable<IFlyerDetailPagePosition> {
  return http
    .post<FlyerDetailPagePositionResponse>(`/positions/`, {
      page: pageId,
      templatePosition: templatePositionId,
    })
    .pipe(map(mapFlyerDetailPagePositionResponseToIFlyerDetailPagePosition));
}

export function fetchPosition(positionId: number): Observable<IFlyerDetailPagePosition> {
  return http
    .get<FlyerDetailPagePositionResponse>(`/positions/${positionId}/`)
    .pipe(map(mapFlyerDetailPagePositionResponseToIFlyerDetailPagePosition));
}

export function savePosition(
  positionId: number,
  changes: Partial<FlyerDetailPagePositionForm>
): Observable<IFlyerDetailPagePosition> {
  return http
    .patch<FlyerDetailPagePositionResponse>(
      `/positions/${positionId}/`,
      mapFlyerDetailPagePositionFormToRequest(changes)
    )
    .pipe(map(mapFlyerDetailPagePositionResponseToIFlyerDetailPagePosition));
}
